export default "__VITE_PUBLIC_ASSET__732b684a__"